const template = {
  materialoptions: [
    {
      name: 'terrain',
      title: 'Terrain',
      type: 'single',
      visible: 'satellite',
      scenematerial: ['Terrain'],
      options: [
        {
          name: 'satellite',
          title: 'Satellite',
          basedon: 'skai_standard',
          payload: { AlbedoPBR: { texture: 'Terrain_diff.jpg' } },
          swatch: 'rgb(16,76,130)'
        },
        {
          name: 'white',
          title: 'White',
          basedon: 'skai_standard',
          payload: { 
            AlbedoPBR: { color: [200, 200, 200] },
            SpecularPBR:{ factor: 0.5 },
          },
          swatch: 'rgb(220,220,220)'
        },
        {
          name: 'diagnostic',
          title: 'Diagnostic',
          basedon: 'skai_standard',
          payload: { AlbedoPBR: { textureurl: 'assets/texture_marked_from_bbox.jpg' } },
          swatch: 'rgb(113,111,112)'
        }
      ]
    },
    {
      name: 'terrain_guangzhou',
      title: 'Terrain',
      type: 'single',
      visible: 'satellite',
      scenematerial: ['Terrain'],
      options: [
        {
          name: 'satellite',
          title: 'Satellite',
          basedon: 'skai_standard',
          payload: { AlbedoPBR: { texture: 'reprojected_d1accc23-7b35-447f-8526-a89aceecc559.png' } },
          icon: 'assets/terrain_swatch.jpg'
        },
        {
          name: 'white',
          title: 'White',
          basedon: 'skai_standard',
          payload: { 
            AlbedoPBR: { color: [200, 200, 200] },
            SpecularPBR:{ factor: 0.5 },
          },
          swatch: 'rgb(220,220,220)'
        }
      ]
    },
    {
      name: 'terrain_venezuela',
      title: 'Terrain',
      type: 'single',
      visible: 'satellite',
      scenematerial: ['Terrain'],
      options: [
        {
          name: 'satellite',
          title: 'Satellite',
          basedon: 'skai_standard',
          payload: { AlbedoPBR: { texture: 'reprojected_2804e91f-2608-4195-bd92-7d94d4ca178b.png' } },
          icon: 'assets/terrain_swatch.jpg'
        },
        {
          name: 'white',
          title: 'White',
          basedon: 'skai_standard',
          payload: { 
            AlbedoPBR: { color: [200, 200, 200] },
            SpecularPBR:{ factor: 0.5 },
          },
          swatch: 'rgb(220,220,220)'
        }
      ]
    },
    {
      name: 'terrain_mekong',
      title: 'Terrain',
      type: 'single',
      visible: 'satellite',
      scenematerial: ['Terrain'],
      options: [
        {
          name: 'satellite',
          title: 'Satellite',
          basedon: 'skai_standard',
          payload: { 
            AlbedoPBR: { texture: 'hochiminh_sat_modified_v3.jpg' },
            AOPBR: {enable: true, factor: 1.5, occludeSpecular:true, textureurl: 'assets/hochiminh_sat_modified_v3_AO.jpg'}
          },
          icon: 'assets/terrain_swatch.jpg'
        },
        // {
        //   name: 'white',
        //   title: 'White',
        //   basedon: 'skai_standard',
        //   payload: { 
        //     AlbedoPBR: { color: [200, 200, 200] },
        //     SpecularPBR:{ factor: 0.5 },
        //   },
        //   swatch: 'rgb(220,220,220)'
        // }
      ]
    },

  ],
  visibilitysingle: [
    {
      title: 'Side support',
      name: 'sidesupport',
      type: 'single',
      visible: true,
      objects: [
          'handle'
      ]
    },
    {
      title: 'Foot bar',
      name: 'footbar',
      type: 'single',
      visible: false,
      objects: [
          'footbar'
      ]
    }
  ],
  visibilitygroup: [  
  ],
  materials: [
    {
      name: 'skai_standard',
      library: 'Skai',
      payload: { 
        AlbedoPBR: {color: [200, 200, 200]},
        SpecularPBR:{ factor: 0.05 },
        RoughnessPBR: {enable: true, factor: 0.7},
        GlossinessPBR: {enable: false},
        Displacement: {enable: true, factor:0}
      }
    }, 
  ],
  views: [
    {
      title: 'Start',
      name: 'start',
      payload: {
        eye: [-21.61,-1540.65,2794.45],
        lookat: [-0.00,2.43,0.02],
        fov: 45
      }
    },
    {
      title: 'Start',
      name: 'start_guangzhou',
      payload: {
        eye: [-0.22,-13.28,28.47],
        lookat: [0.00,2.43,0.02],
        fov: 45
      }
    },
    {
      title: 'Site 1',
      name: 'site1',
      payload: {
        eye: [2177.71,-8449.06,5227.57],
        lookat: [393.62,-4105.15,663.50],
        fov: 45
      }
    },
    {
      title: 'Side',
      name: 'side',
      payload: {
        eye: [-23321.71,18690.01,11313.89],
        lookat: [-167.63,1138.34,-1025.99],
        fov: 45
      }
    }
  ],
  player: [
    {
      name: 'sensar',
      library: 'avoidunder',
      payload: {
        // orbit_constraint_zoom_in: 500,
        // orbit_constraint_zoom_out: 3500,
        preload: 0,
        // transparent: playerSettings.transparent,
        camera: 1, // skips the entry animation, we have more control by setting the viewer position manually
        //  blending: 0,  
        annotations_visible: 1,
        autospin: 0.02,
        ui_annotations: 1,
        ui_stop: 0,
        ui_infos: 0, // need biz account
        ui_controls: 0, // need biz account
        ui_watermark: 0,
        scrollwheel: 1,
        graph_optimizer: 0,
        merge_materials: 0,
        allow_swift_shader: 1, //this might help with remote desktop systems
  
      }
    },
    {
      name: 'free',
      library: 'free',
      payload: {
      }
    }
  ],
  background: [
    {
      name: 'sensar',
      library: 'darkgrey',
      payload: {
      }
    }
  ],
  environment: [
    {
      name: 'lojer',
      library: 'lojer',
      payload: {
      }
    }
  ],
  postprocessing: [
    {
      name: 'lojer',
      library: 'everything_off',
      payload: {
        ssaoBias: 0.2,
        ssaoEnable: true,
        ssaoIntensity: 0.2,
        ssaoRadius: 3
      }
    }
  ],
  annotations: [
    
  ],
  labels: [
    {
      name: 'wheel',
      title: 'Wheels',
      payload: {
        text: 'Site 1 is the main drilling and pumping station.'
      }
    }
  ],
  animations: [

  ],
  sensar: [
    {
      name: 'hochiminh',
      title: 'Sequence 2017-2019',
      payload: {
        startframe: 1,
        endframe: 299,
        playbackspeed: 10,
        currentframe: 0,
        deformationurl: 'assets/deformation/2020-08-17/',
        deformationmultiplier: 20,
        deformation:[
          {
            date: '2017-11-15',
            displacement: '20171115.png',
            albedo: '20171115_color.png'
          },
          {
            date: '2017-11-27',
            displacement: '20171127.png',
            albedo: '20171127_color.png'
          },
          {
            date: '2017-12-09',
            displacement: '20171209.png',
            albedo: '20171209_color.png'
          },
          {
            date: '2017-12-21',
            displacement: '20171221.png',
            albedo: '20171221_color.png'
          },
          {
            date: '2018-01-02',
            displacement: '20180102.png',
            albedo: '20180102_color.png'
          },
          {
            date: '2018-01-14',
            displacement: '20180114.png',
            albedo: '20180114_color.png'
          },
          {
            date: '2018-01-26',
            displacement: '20180126.png',
            albedo: '20180126_color.png'
          },
          {
            date: '2018-02-07',
            displacement: '20180207.png',
            albedo: '20180207_color.png'
          },
          {
            date: '2018-02-19',
            displacement: '20180219.png',
            albedo: '20180219_color.png'
          },
          {
            date: '2018-03-03',
            displacement: '20180303.png',
            albedo: '20180303_color.png'
          },
          {
            date: '2018-03-15',
            displacement: '20180315.png',
            albedo: '20180315_color.png'
          },
          {
            date: '2018-03-27',
            displacement: '20180327.png',
            albedo: '20180327_color.png'
          },
          {
            date: '2018-04-08',
            displacement: '20180408.png',
            albedo: '20180408_color.png'
          },
          {
            date: '2018-04-20',
            displacement: '20180420.png',
            albedo: '20180420_color.png'
          },
          {
            date: '2018-05-02',
            displacement: '20180502.png',
            albedo: '20180502_color.png'
          },
          {
            date: '2018-05-14',
            displacement: '20180514.png',
            albedo: '20180514_color.png'
          },
          {
            date: '2018-05-26',
            displacement: '20180526.png',
            albedo: '20180526_color.png'
          },
          {
            date: '2018-06-07',
            displacement: '20180607.png',
            albedo: '20180607_color.png'
          },
          {
            date: '2018-06-19',
            displacement: '20180619.png',
            albedo: '20180619_color.png'
          },
          {
            date: '2018-07-13',
            displacement: '20180713.png',
            albedo: '20180713_color.png'
          },
          {
            date: '2018-07-25',
            displacement: '20180725.png',
            albedo: '20180725_color.png'
          },
          {
            date: '2018-08-06',
            displacement: '20180806.png',
            albedo: '20180806_color.png'
          },
          {
            date: '2018-08-16',
            displacement: '20180816.png',
            albedo: '20180816_color.png'
          },
          {
            date: '2018-08-18',
            displacement: '20180818.png',
            albedo: '20180818_color.png'
          },
          {
            date: '2018-08-22',
            displacement: '20180822.png',
            albedo: '20180822_color.png'
          },
          {
            date: '2018-08-28',
            displacement: '20180828.png',
            albedo: '20180828_color.png'
          },
          {
            date: '2018-08-30',
            displacement: '20180830.png',
            albedo: '20180830_color.png'
          },
          {
            date: '2018-09-03',
            displacement: '20180903.png',
            albedo: '20180903_color.png'
          },
          {
            date: '2018-09-09',
            displacement: '20180909.png',
            albedo: '20180909_color.png'
          },
          {
            date: '2018-09-11',
            displacement: '20180911.png',
            albedo: '20180911_color.png'
          },
          {
            date: '2018-09-15',
            displacement: '20180915.png',
            albedo: '20180915_color.png'
          },
          {
            date: '2018-09-21',
            displacement: '20180921.png',
            albedo: '20180921_color.png'
          },
          {
            date: '2018-09-23',
            displacement: '20180923.png',
            albedo: '20180923_color.png'
          },
          {
            date: '2018-09-27',
            displacement: '20180927.png',
            albedo: '20180927_color.png'
          },
          {
            date: '2018-10-03',
            displacement: '20181003.png',
            albedo: '20181003_color.png'
          },
          {
            date: '2018-10-05',
            displacement: '20181005.png',
            albedo: '20181005_color.png'
          },
          {
            date: '2018-10-09',
            displacement: '20181009.png',
            albedo: '20181009_color.png'
          },
          {
            date: '2018-10-15',
            displacement: '20181015.png',
            albedo: '20181015_color.png'
          },
          {
            date: '2018-10-17',
            displacement: '20181017.png',
            albedo: '20181017_color.png'
          },
          {
            date: '2018-10-21',
            displacement: '20181021.png',
            albedo: '20181021_color.png'
          },
          {
            date: '2018-10-27',
            displacement: '20181027.png',
            albedo: '20181027_color.png'
          },
          {
            date: '2018-10-29',
            displacement: '20181029.png',
            albedo: '20181029_color.png'
          },
          {
            date: '2018-11-02',
            displacement: '20181102.png',
            albedo: '20181102_color.png'
          },
          {
            date: '2018-11-08',
            displacement: '20181108.png',
            albedo: '20181108_color.png'
          },
          {
            date: '2018-11-10',
            displacement: '20181110.png',
            albedo: '20181110_color.png'
          },
          {
            date: '2018-11-14',
            displacement: '20181114.png',
            albedo: '20181114_color.png'
          },
          {
            date: '2018-11-20',
            displacement: '20181120.png',
            albedo: '20181120_color.png'
          },
          {
            date: '2018-11-22',
            displacement: '20181122.png',
            albedo: '20181122_color.png'
          },
          {
            date: '2018-11-26',
            displacement: '20181126.png',
            albedo: '20181126_color.png'
          },
          {
            date: '2018-12-02',
            displacement: '20181202.png',
            albedo: '20181202_color.png'
          },
          {
            date: '2018-12-04',
            displacement: '20181204.png',
            albedo: '20181204_color.png'
          },
          {
            date: '2018-12-08',
            displacement: '20181208.png',
            albedo: '20181208_color.png'
          },
          {
            date: '2018-12-14',
            displacement: '20181214.png',
            albedo: '20181214_color.png'
          },
          {
            date: '2018-12-16',
            displacement: '20181216.png',
            albedo: '20181216_color.png'
          },
          {
            date: '2018-12-20',
            displacement: '20181220.png',
            albedo: '20181220_color.png'
          },
          {
            date: '2018-12-26',
            displacement: '20181226.png',
            albedo: '20181226_color.png'
          },
          {
            date: '2018-12-28',
            displacement: '20181228.png',
            albedo: '20181228_color.png'
          },
          {
            date: '2019-01-01',
            displacement: '20190101.png',
            albedo: '20190101_color.png'
          },
          {
            date: '2019-01-07',
            displacement: '20190107.png',
            albedo: '20190107_color.png'
          },
          {
            date: '2019-01-09',
            displacement: '20190109.png',
            albedo: '20190109_color.png'
          },
          {
            date: '2019-01-13',
            displacement: '20190113.png',
            albedo: '20190113_color.png'
          },
          {
            date: '2019-01-19',
            displacement: '20190119.png',
            albedo: '20190119_color.png'
          },
          {
            date: '2019-01-25',
            displacement: '20190125.png',
            albedo: '20190125_color.png'
          },
          {
            date: '2019-01-31',
            displacement: '20190131.png',
            albedo: '20190131_color.png'
          },
          {
            date: '2019-02-02',
            displacement: '20190202.png',
            albedo: '20190202_color.png'
          },
          {
            date: '2019-02-06',
            displacement: '20190206.png',
            albedo: '20190206_color.png'
          },
          {
            date: '2019-02-12',
            displacement: '20190212.png',
            albedo: '20190212_color.png'
          },
          {
            date: '2019-02-14',
            displacement: '20190214.png',
            albedo: '20190214_color.png'
          },
          {
            date: '2019-02-18',
            displacement: '20190218.png',
            albedo: '20190218_color.png'
          },
          {
            date: '2019-02-24',
            displacement: '20190224.png',
            albedo: '20190224_color.png'
          },
          {
            date: '2019-02-26',
            displacement: '20190226.png',
            albedo: '20190226_color.png'
          },
          {
            date: '2019-03-02',
            displacement: '20190302.png',
            albedo: '20190302_color.png'
          },
          {
            date: '2019-03-08',
            displacement: '20190308.png',
            albedo: '20190308_color.png'
          },
          {
            date: '2019-03-10',
            displacement: '20190310.png',
            albedo: '20190310_color.png'
          },
          {
            date: '2019-03-14',
            displacement: '20190314.png',
            albedo: '20190314_color.png'
          },
          {
            date: '2019-03-20',
            displacement: '20190320.png',
            albedo: '20190320_color.png'
          },
          {
            date: '2019-03-22',
            displacement: '20190322.png',
            albedo: '20190322_color.png'
          },
          {
            date: '2019-03-26',
            displacement: '20190326.png',
            albedo: '20190326_color.png'
          },
          {
            date: '2019-04-01',
            displacement: '20190401.png',
            albedo: '20190401_color.png'
          },
          {
            date: '2019-04-03',
            displacement: '20190403.png',
            albedo: '20190403_color.png'
          },
          {
            date: '2019-04-07',
            displacement: '20190407.png',
            albedo: '20190407_color.png'
          },
          {
            date: '2019-04-13',
            displacement: '20190413.png',
            albedo: '20190413_color.png'
          },
          {
            date: '2019-04-15',
            displacement: '20190415.png',
            albedo: '20190415_color.png'
          },
          {
            date: '2019-04-19',
            displacement: '20190419.png',
            albedo: '20190419_color.png'
          },
          {
            date: '2019-04-25',
            displacement: '20190425.png',
            albedo: '20190425_color.png'
          },
          {
            date: '2019-04-27',
            displacement: '20190427.png',
            albedo: '20190427_color.png'
          },
          {
            date: '2019-05-01',
            displacement: '20190501.png',
            albedo: '20190501_color.png'
          },
          {
            date: '2019-05-07',
            displacement: '20190507.png',
            albedo: '20190507_color.png'
          },
          {
            date: '2019-05-09',
            displacement: '20190509.png',
            albedo: '20190509_color.png'
          },
          {
            date: '2019-05-13',
            displacement: '20190513.png',
            albedo: '20190513_color.png'
          },
          {
            date: '2019-05-19',
            displacement: '20190519.png',
            albedo: '20190519_color.png'
          },
          {
            date: '2019-05-21',
            displacement: '20190521.png',
            albedo: '20190521_color.png'
          },
          {
            date: '2019-05-25',
            displacement: '20190525.png',
            albedo: '20190525_color.png'
          },
          {
            date: '2019-05-31',
            displacement: '20190531.png',
            albedo: '20190531_color.png'
          },
          {
            date: '2019-06-02',
            displacement: '20190602.png',
            albedo: '20190602_color.png'
          },
          {
            date: '2019-06-06',
            displacement: '20190606.png',
            albedo: '20190606_color.png'
          },
          {
            date: '2019-06-12',
            displacement: '20190612.png',
            albedo: '20190612_color.png'
          },
          {
            date: '2019-06-14',
            displacement: '20190614.png',
            albedo: '20190614_color.png'
          },
          {
            date: '2019-06-18',
            displacement: '20190618.png',
            albedo: '20190618_color.png'
          },
          {
            date: '2019-06-24',
            displacement: '20190624.png',
            albedo: '20190624_color.png'
          },
          {
            date: '2019-06-30',
            displacement: '20190630.png',
            albedo: '20190630_color.png'
          },
          {
            date: '2019-07-06',
            displacement: '20190706.png',
            albedo: '20190706_color.png'
          },
          {
            date: '2019-07-12',
            displacement: '20190712.png',
            albedo: '20190712_color.png'
          },
          {
            date: '2019-07-18',
            displacement: '20190718.png',
            albedo: '20190718_color.png'
          },
          {
            date: '2019-07-20',
            displacement: '20190720.png',
            albedo: '20190720_color.png'
          },
          {
            date: '2019-07-30',
            displacement: '20190730.png',
            albedo: '20190730_color.png'
          },
          {
            date: '2019-08-01',
            displacement: '20190801.png',
            albedo: '20190801_color.png'
          },
          {
            date: '2019-08-05',
            displacement: '20190805.png',
            albedo: '20190805_color.png'
          },
          {
            date: '2019-08-11',
            displacement: '20190811.png',
            albedo: '20190811_color.png'
          },
          {
            date: '2019-08-13',
            displacement: '20190813.png',
            albedo: '20190813_color.png'
          },
          {
            date: '2019-08-17',
            displacement: '20190817.png',
            albedo: '20190817_color.png'
          },
          {
            date: '2019-08-23',
            displacement: '20190823.png',
            albedo: '20190823_color.png'
          },
          {
            date: '2019-08-25',
            displacement: '20190825.png',
            albedo: '20190825_color.png'
          },
          {
            date: '2019-08-29',
            displacement: '20190829.png',
            albedo: '20190829_color.png'
          },
          {
            date: '2019-09-04',
            displacement: '20190904.png',
            albedo: '20190904_color.png'
          },
          {
            date: '2019-09-10',
            displacement: '20190910.png',
            albedo: '20190910_color.png'
          },
          {
            date: '2019-09-16',
            displacement: '20190916.png',
            albedo: '20190916_color.png'
          },
          {
            date: '2019-09-18',
            displacement: '20190918.png',
            albedo: '20190918_color.png'
          },
          {
            date: '2019-09-22',
            displacement: '20190922.png',
            albedo: '20190922_color.png'
          },
          {
            date: '2019-09-28',
            displacement: '20190928.png',
            albedo: '20190928_color.png'
          },
          {
            date: '2019-09-30',
            displacement: '20190930.png',
            albedo: '20190930_color.png'
          },
          {
            date: '2019-10-04',
            displacement: '20191004.png',
            albedo: '20191004_color.png'
          },
          {
            date: '2019-10-10',
            displacement: '20191010.png',
            albedo: '20191010_color.png'
          },
          {
            date: '2019-10-12',
            displacement: '20191012.png',
            albedo: '20191012_color.png'
          },
          {
            date: '2019-10-16',
            displacement: '20191016.png',
            albedo: '20191016_color.png'
          },
          {
            date: '2019-10-22',
            displacement: '20191022.png',
            albedo: '20191022_color.png'
          },
          {
            date: '2019-10-24',
            displacement: '20191024.png',
            albedo: '20191024_color.png'
          },
          {
            date: '2019-10-28',
            displacement: '20191028.png',
            albedo: '20191028_color.png'
          },
          {
            date: '2019-11-03',
            displacement: '20191103.png',
            albedo: '20191103_color.png'
          },
        ]
      }
    },    
  ]
}
  
export default template;